import styled from 'styled-components'

export const ModalContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
